export function checkIfDefaultName(flow) {
  if (!flow.name) {
    return false;
  }
  const defaultNameRegex = /^Unnamed [Ww]orkflow(?:$|(?:\s-\s\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}\sGMT(?:[+-]\d{4})?(?:$|\s\(cloned\)$)))/;
  return defaultNameRegex.test(flow.name);
}